import { render } from "./ModalMedRules.vue?vue&type=template&id=7b9ec8db"
import script from "./ModalMedRules.vue?vue&type=script&lang=js"
export * from "./ModalMedRules.vue?vue&type=script&lang=js"

import "./ModalMedRules.vue?vue&type=style&index=0&id=7b9ec8db&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__